import { render, staticRenderFns } from "./WHMD08Result.vue?vue&type=template&id=5fbe01d3&"
import script from "./WHMD08Result.vue?vue&type=script&lang=js&"
export * from "./WHMD08Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports